// extracted by mini-css-extract-plugin
export default {"button":"CommonErrorModal_button__x81Ni"};